import { NgFor } from '@angular/common';
import { Component, Input } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { ProfileCandidateScoreRating } from 'src/app/martech/models/candidate-score-rating.model';
import { RatingNameComponent } from 'src/app/shared/components/rating-name/rating-name.component';

@UntilDestroy()
@Component({
    selector: 'nova-lead-score-profile-rating',
    templateUrl: './lead-score-profile-rating.component.html',
    styleUrls: ['./lead-score-profile-rating.component.scss'],
    standalone: true,
    imports: [NgFor, RatingNameComponent]
})
export class LeadScoreProfileRatingComponent {
    @Input()
    leadScoreProfiles: ProfileCandidateScoreRating[];

    @Input()
    showIconAndHeader = false;
}
